module.exports = __webpack_public_path__ + "assets/media/evening.13f8428a.mp3";